import { DatePicker, Form, Input, message, Modal, TimePicker } from "antd";
import dayjs, { Dayjs } from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import { IEventFormData, IEventFormModal } from "../type/events.types";
import { useForm } from "antd/lib/form/Form";
import events from "../../../resources/event";
import {
    createEvent,
    mapEventFormToPayload,
    mapEventToForm,
    mapPayloadToCalendarEvent,
    updateEvent
} from "../action/events.actions";
import AddTags from "../../common/tags/add-tags";
import Locale from "../../../core/locale/locale";
import { Segmented, Select } from "antd/lib";
import { Event_Type } from "../../../constant/constant";
import DocumentUploader from "../../common/document-uploader/document-uploader";
import TiptapEditor from "../../common/tiptap-editor/tiptap-editor";

const EventFormModal: React.FC<IEventFormModal> = (props) => {
    const [eventForm] = useForm();
    const resource = events.EventFormModal;
    const initialData = mapEventToForm(props.event);
    const documentRef = useRef<any>(null);
    // const isEventStarted=props.mode ==='edit' && dayjs(`${props.event.startDate}T${props.event.startTime}`).isBefore(dayjs());

    useEffect(() => {
        if (initialData) {
            eventForm.setFieldsValue(initialData);
        } else {
            eventForm.resetFields();
        }
    }, [initialData, eventForm]);

    //disable past 15 day dates , sunday's and saturday's
    const disableEventDate = (currentDate: Dayjs): boolean => {
        if (!currentDate) return false;
        const isPastDays = currentDate.isBefore(dayjs().subtract(15, 'day'), 'date');
        const isWeekend = currentDate.day() === 0 || currentDate.day() === 6;
        return isPastDays || isWeekend;
    };

    async function handleCancel() {
        eventForm.resetFields();
        props.closeEventModal();
    }

    const extractEventId = (path: string): string => {
        const prefix = "/v1/event/";
        if (!path.startsWith(prefix)) {
            return path;
        }
        return path.slice(prefix.length);
    };

    async function handleSubmit(values: IEventFormData) {
        let documentId = '';
        if (documentRef.current) {
            documentId = await documentRef.current.uploadDocument();
        }

        if (documentId) {
            values.coverImageId = documentId;
        }
        const payload = mapEventFormToPayload(values);
        let messageText = '';
        let eventId = '';

        try {
            if (props.mode === 'edit' && initialData) {
                const id = initialData.id || values.id;
                await updateEvent(id, payload);
                eventId = id;
                messageText = 'Event updated!';
            } else if (props.mode === 'add') {
                const res = await createEvent(payload);
                eventId = extractEventId(res);
                messageText = "New event added!";
            } else {
                throw new Error('Something went wrong');
            }

            const event = mapPayloadToCalendarEvent(eventId, payload)
            props.upsertEvent(event);

            handleCancel();
            message.success(messageText);
        } catch (error) {
            console.log(error);
        }
    }

    async function handleModalOkClick() {
        const values = eventForm.getFieldsValue();
        await handleSubmit(values);
    }



    const title = props.mode === 'edit' ? resource.editEventModalTitle : resource.addEventModalTitle;

    const eventTypeOptions = [{label: 'Custom Event', value: 'CUSTOM_EVENT'}, {label: 'Trainings', value: 'TRAINING'}];





    return (
        <Modal
            className="hrms-app event-form-modal"
            title={title}
            centered
            open={props.open}
            onCancel={handleCancel}
            okText={resource.submitButtonText}
            onOk={handleModalOkClick}
        >
            <Form
                layout="vertical"
                onFinish={handleSubmit}
                form={eventForm}
            >
                <div className={'event-form-modal__name-type-wrapper'}>
                    <Form.Item
                        className="event-form-modal__name"
                        label="Name"
                        name="name"
                        rules={[{required: true, message: 'Please input!'}]}
                    >
                        <Input placeholder={"Enter event name"}/>
                    </Form.Item>
                    <Form.Item
                        className="event-form-modal__event-type"
                        label="Event Type"
                        name="eventType"
                        rules={[{required: true, message: 'Please input!'}]}
                    >
                        <Segmented
                            options={eventTypeOptions}
                        />
                    </Form.Item>
                </div>


                <div className={'event-form-modal__date-time-wrapper'}>
                    <Form.Item
                        label={'Date'}
                        className="event-form-modal__datepicker"
                        name="date"
                        rules={[{required: true, message: 'Select start time'}]}
                    >
                        <DatePicker.RangePicker
                            format={Locale.displayDate}
                            // onCalendarChange={(dates) => {
                            //     console.log('date selected',dates)
                            //     setSelectedStartDate(dates?.[0] || null);
                            // }}
                            // disabled={isEventStarted}
                            disabledDate={disableEventDate}
                            className={'event-form-modal__range-picker'}
                        />
                    </Form.Item>

                    <Form.Item
                        label={'Time'}
                        className="event-form-modal__timepicker"
                        name="time"
                        rules={[{required: true, message: 'Select start time'}]}
                    >
                        <TimePicker.RangePicker
                            // disabled={isEventStarted}
                            className={"event-form-modal__timepicker"} format="HH:mm"/>
                    </Form.Item>
                </div>

                <div className={'event-form-modal__venue-host-wrapper'}>
                    <Form.Item
                        className="event-form-modal__venue"
                        label="Venue"
                        name="venue"
                        rules={[{required: true, message: 'Please input!'}]}
                    >
                        <Input placeholder={"Enter event venue"}/>
                    </Form.Item>

                    <Form.Item
                        className="event-form-modal__host"
                        label="Host Name"
                        name="hostBy"
                        rules={[{required: true, message: 'Please input!'}]}
                    >
                        <Input placeholder={'Enter host name'}/>
                    </Form.Item>
                </div>
                <Form.Item
                    className="event-form-modal__description"
                    label="Description"
                    name="description"
                    rules={[{required: true, message: 'Please input!'}]}
                >
                    <TiptapEditor/>
                </Form.Item>
                <div className={'event-form-modal__coverImg-externalEmail-wrapper'}>
                    <Form.Item
                        className="event-form-modal__cover-image"
                        label="Attach Cover Image"
                        name="coverImageId"
                    >
                        <DocumentUploader
                            uploadButtonText={'Upload Cover Image'}
                            ref={documentRef}
                            disabled={false}
                            docType={'EVENT_PHOTO'}
                            uploadMode="onSubmit"
                        />
                    </Form.Item>
                    <Form.Item
                        label={"Add External Emails"}
                        name={["externalEmails"]}
                        className={'externalEmailField'}
                    >
                        <AddTags tagLabel={'Add Email'}/>
                    </Form.Item>

                </div>

            </Form>
        </Modal>
    )
}

export default EventFormModal;
